import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Loader from "../../../CustomComponents/Loader/Loader";
import styles from "./DashboardCustomer.module.scss"

const DashboardCustomer = () => {
  const [loader, setLoader] = useState(true);
  const [overviewData, setOverviewData] = useState([]);
  const userToken = localStorage.getItem("token");
  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 500);
  }, []);

  const { id: propertyId } = useParams();

  const fetchVendorOverview = () => {
    // const myHeaders = new Headers();
    // myHeaders.append("key", "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1");
    // myHeaders.append("token", localStorage.getItem("token"));
    //   const  myHeaders: {
    //         "Content-Type": "application/json",
    //         key: "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1",
    //         Authorization: "Bearer " + localStorage.getItem("token"),
    //       }

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        key: process.env.REACT_APP_BASE_API_KEY,
        Authorization: "Bearer " + userToken,
      },
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/customers/get-dashboard-detail`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) console.log(result);
        setOverviewData(result);
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchVendorOverview();
  }, []);

  return (
    <section className="w-full">
      <div className="mt-20 bg-white-div">
        <div>
         <h4 className={styles.agent_dashboard_new_heading}>Dashboard</h4>
        </div>
        {loader ? (
          <Loader size="4em" color="#016937" />
        ) : (
          // <div className="property-details-flex">
          //   <div className="property_details p_20" id="propertyDetails">
          //     <span className="font-3 font_12">
          //       {overviewData?.data?.total_bookings}
          //     </span>
          //     <h6> Total Bookings </h6>
          //   </div>
          //   <div className="property_details p_20" id="propertyDetails">
          //     <span className="font-3 font_12">
          //       {overviewData?.data?.confermedbookings}
          //     </span>
          //     <h6> Confirmed Bookings </h6>
          //   </div>
          //   <div className="property_details p_20" id="propertyDetails">
          //     <span className="font-3 font_12">
          //       {overviewData?.data?.cancelledbookings}
          //     </span>
          //     <h6> Cancelled Bookings </h6>
          //   </div>
          // </div>
          <div className={styles.property_details_flex}>
            <div className={styles.property_details}>
              <span className="font-3 font_12">
                {overviewData?.data?.today_average_revenue}
              </span>
              <div className="flex align_items_center justify_content_between">
                <h6>Today's Average Revenue </h6>
                <svg
                  width="31"
                  height="30"
                  viewBox="0 0 31 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.914062"
                    y="0.25"
                    width="29.5"
                    height="29.5"
                    rx="14.75"
                    strokeWidth="0.5"
                  />
                  <mask
                    id="mask0_6855_7898"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="2"
                    width="27"
                    height="26"
                  >
                    <rect
                      x="15.6641"
                      y="27.728"
                      width="18"
                      height="18"
                      transform="rotate(-135 15.6641 27.728)"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6855_7898)">
                    <path
                      d="M18.621 12.5718L12.4805 18.7124C12.405 18.7878 12.3166 18.8256 12.2153 18.8256C12.114 18.8256 12.0256 18.7878 11.9501 18.7124C11.8747 18.6369 11.8369 18.5485 11.8369 18.4472C11.8369 18.3459 11.8747 18.2575 11.9501 18.182L18.0907 12.0415L12.3224 12.0413C12.2191 12.0414 12.1312 12.0076 12.0587 11.9399C11.9863 11.8723 11.9501 11.78 11.9501 11.6629C11.9522 11.5481 11.986 11.4569 12.0516 11.3892C12.1172 11.3215 12.2085 11.2877 12.3254 11.2877L18.775 11.2877C18.8676 11.2877 18.9474 11.3025 19.0143 11.3321C19.0813 11.3617 19.1433 11.405 19.2004 11.4621C19.2575 11.5192 19.3008 11.5812 19.3304 11.6482C19.36 11.7151 19.3748 11.7949 19.3748 11.8875L19.3748 18.3371C19.3748 18.4363 19.341 18.5232 19.2733 18.5977C19.2056 18.6721 19.1144 18.7103 18.9996 18.7124C18.8825 18.7124 18.7902 18.6785 18.7226 18.6109C18.6549 18.5432 18.6211 18.4509 18.6212 18.334L18.621 12.5718Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svg>
              </div>

              {/* <h2>{overviewData?.data?.today_average_revenue}</h2> */}
              {/* <span>For Last 7 Days: 100 Bookings</span> */}
            </div>
            <div className={styles.property_details}>
              <span className="font-3 font_12">
                {overviewData?.data?.today_checkin}
              </span>
              <div className="flex align_items_center justify_content_between">
                {" "}
                <h6>Today's Checkin</h6>{" "}
                <svg
                  width="31"
                  height="30"
                  viewBox="0 0 31 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.914062"
                    y="0.25"
                    width="29.5"
                    height="29.5"
                    rx="14.75"
                    strokeWidth="0.5"
                  />
                  <mask
                    id="mask0_6855_7898"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="2"
                    width="27"
                    height="26"
                  >
                    <rect
                      x="15.6641"
                      y="27.728"
                      width="18"
                      height="18"
                      transform="rotate(-135 15.6641 27.728)"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6855_7898)">
                    <path
                      d="M18.621 12.5718L12.4805 18.7124C12.405 18.7878 12.3166 18.8256 12.2153 18.8256C12.114 18.8256 12.0256 18.7878 11.9501 18.7124C11.8747 18.6369 11.8369 18.5485 11.8369 18.4472C11.8369 18.3459 11.8747 18.2575 11.9501 18.182L18.0907 12.0415L12.3224 12.0413C12.2191 12.0414 12.1312 12.0076 12.0587 11.9399C11.9863 11.8723 11.9501 11.78 11.9501 11.6629C11.9522 11.5481 11.986 11.4569 12.0516 11.3892C12.1172 11.3215 12.2085 11.2877 12.3254 11.2877L18.775 11.2877C18.8676 11.2877 18.9474 11.3025 19.0143 11.3321C19.0813 11.3617 19.1433 11.405 19.2004 11.4621C19.2575 11.5192 19.3008 11.5812 19.3304 11.6482C19.36 11.7151 19.3748 11.7949 19.3748 11.8875L19.3748 18.3371C19.3748 18.4363 19.341 18.5232 19.2733 18.5977C19.2056 18.6721 19.1144 18.7103 18.9996 18.7124C18.8825 18.7124 18.7902 18.6785 18.7226 18.6109C18.6549 18.5432 18.6211 18.4509 18.6212 18.334L18.621 12.5718Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svg>{" "}
              </div>
              {/* <h2>₹50,000</h2>
            <span>For Last 7 Days: ₹50,000 Payout</span> */}
            </div>
            <div className={styles.property_details}>
              <span className="font-3 font_12">
                {overviewData?.data?.today_room_nights}
              </span>
              <div className="flex align_items_center justify_content_between">
                {" "}
                <h6>Today's Room Nights</h6>{" "}
                <svg
                  width="31"
                  height="30"
                  viewBox="0 0 31 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.914062"
                    y="0.25"
                    width="29.5"
                    height="29.5"
                    rx="14.75"
                    strokeWidth="0.5"
                  />
                  <mask
                    id="mask0_6855_7898"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="2"
                    width="27"
                    height="26"
                  >
                    <rect
                      x="15.6641"
                      y="27.728"
                      width="18"
                      height="18"
                      transform="rotate(-135 15.6641 27.728)"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6855_7898)">
                    <path
                      d="M18.621 12.5718L12.4805 18.7124C12.405 18.7878 12.3166 18.8256 12.2153 18.8256C12.114 18.8256 12.0256 18.7878 11.9501 18.7124C11.8747 18.6369 11.8369 18.5485 11.8369 18.4472C11.8369 18.3459 11.8747 18.2575 11.9501 18.182L18.0907 12.0415L12.3224 12.0413C12.2191 12.0414 12.1312 12.0076 12.0587 11.9399C11.9863 11.8723 11.9501 11.78 11.9501 11.6629C11.9522 11.5481 11.986 11.4569 12.0516 11.3892C12.1172 11.3215 12.2085 11.2877 12.3254 11.2877L18.775 11.2877C18.8676 11.2877 18.9474 11.3025 19.0143 11.3321C19.0813 11.3617 19.1433 11.405 19.2004 11.4621C19.2575 11.5192 19.3008 11.5812 19.3304 11.6482C19.36 11.7151 19.3748 11.7949 19.3748 11.8875L19.3748 18.3371C19.3748 18.4363 19.341 18.5232 19.2733 18.5977C19.2056 18.6721 19.1144 18.7103 18.9996 18.7124C18.8825 18.7124 18.7902 18.6785 18.7226 18.6109C18.6549 18.5432 18.6211 18.4509 18.6212 18.334L18.621 12.5718Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svg>{" "}
              </div>{" "}
              {/* <h2>₹10,000</h2>
            <span>For Last 7 Days: ₹50,000 Payouts</span> */}
            </div>
            <div className={styles.property_details}>
              <span className="font-3 font_12">
                {overviewData?.data?.today_room_nights}
              </span>
              <div className="flex align_items_center justify_content_between">
                {" "}
                <h6>Today's Revenue</h6>{" "}
                <svg
                  width="31"
                  height="30"
                  viewBox="0 0 31 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.914062"
                    y="0.25"
                    width="29.5"
                    height="29.5"
                    rx="14.75"
                    strokeWidth="0.5"
                  />
                  <mask
                    id="mask0_6855_7898"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="2"
                    width="27"
                    height="26"
                  >
                    <rect
                      x="15.6641"
                      y="27.728"
                      width="18"
                      height="18"
                      transform="rotate(-135 15.6641 27.728)"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6855_7898)">
                    <path
                      d="M18.621 12.5718L12.4805 18.7124C12.405 18.7878 12.3166 18.8256 12.2153 18.8256C12.114 18.8256 12.0256 18.7878 11.9501 18.7124C11.8747 18.6369 11.8369 18.5485 11.8369 18.4472C11.8369 18.3459 11.8747 18.2575 11.9501 18.182L18.0907 12.0415L12.3224 12.0413C12.2191 12.0414 12.1312 12.0076 12.0587 11.9399C11.9863 11.8723 11.9501 11.78 11.9501 11.6629C11.9522 11.5481 11.986 11.4569 12.0516 11.3892C12.1172 11.3215 12.2085 11.2877 12.3254 11.2877L18.775 11.2877C18.8676 11.2877 18.9474 11.3025 19.0143 11.3321C19.0813 11.3617 19.1433 11.405 19.2004 11.4621C19.2575 11.5192 19.3008 11.5812 19.3304 11.6482C19.36 11.7151 19.3748 11.7949 19.3748 11.8875L19.3748 18.3371C19.3748 18.4363 19.341 18.5232 19.2733 18.5977C19.2056 18.6721 19.1144 18.7103 18.9996 18.7124C18.8825 18.7124 18.7902 18.6785 18.7226 18.6109C18.6549 18.5432 18.6211 18.4509 18.6212 18.334L18.621 12.5718Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svg>{" "}
              </div>{" "}
              {/* <h2>₹10,000</h2>
            <span>For Last 7 Days: ₹50,000 Payouts</span> */}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DashboardCustomer;
